import React from 'react'
import PropTypes from 'prop-types'
import { ChromePicker } from 'react-color';
import FormLabel from 'components/labels/FormLabel'

const createColorString = ({ r, g, b, a }) => `rgba(${r}, ${g}, ${b}, ${a})`

const ColorPicker = ({
  label,
  value,
  onChange,
}) => {
  return (
    <div>
      <FormLabel dark style={{ marginBottom: 5 }}>{label}</FormLabel>
      <ChromePicker
        color={value}
        onChangeComplete={
          (color) => onChange(createColorString(color.rgb))
        }
      />
    </div>
  )
}

ColorPicker.propTypes = {}
ColorPicker.defaultProps = {}

export default ColorPicker



// WEBPACK FOOTER //
// ./src/components/forms/ColorPicker.js